import { ArrowLeft, BankIcon, LogoIconSmall } from '@/shared/assets';
import {
  DashboardDialogProps,
  ModalCard,
  ModalCardItemWithIcon,
} from '@/shared/ui';
import { Soon } from '@/shared/ui/components/soon';

import { MoneyFlowType } from '../../../../model/types';
import { useSendMoney } from '../../../../model/useSendMoney';

const AddRecipient: React.FC<{
  setStep: (step: MoneyFlowType) => void;
}> = ({ setStep }) => {
  const resetData = useSendMoney((state) => state.resetData);
  return (
    <div className="mt-1 flex flex-col gap-y-1">
      <ModalCard>
        <ModalCardItemWithIcon
          title="Find on FCB"
          description="By e-mail or mobile number"
          icon={<LogoIconSmall className="h-6 w-6" />}
          as="button"
          className="text-left"
          noWrapper
          rightContent={<Soon text="Faster" className="bg-base-100" />}
          onClick={() => {
            resetData();
            setStep('find-client');
          }}
        />
        <ModalCardItemWithIcon
          title="Bank details"
          description="Enter name and other details"
          icon={<BankIcon className="h-6 w-6" />}
          as="button"
          noWrapper
          className="text-left"
          onClick={() => {
            setStep('choose-flow');
          }}
        />
      </ModalCard>
    </div>
  );
};

interface AddRecipientProps {
  setStep: (step: MoneyFlowType) => void;
  onBack: () => void;
  isFirst: boolean;
}

export const addRecipientProps = ({
  setStep,
  onBack,
  isFirst,
}: AddRecipientProps): DashboardDialogProps => {
  return {
    title: 'Add a recipient',
    content: <AddRecipient setStep={setStep} />,
    animationProps: {
      id: 'choose',
      isFirst: isFirst,
    },
    modalProps: {
      classNames: {
        title: 'max-w-[235px] px-5',
      },
    },
    disableOutsideClick: !isFirst,
    serviceButton: !isFirst
      ? {
          icon: <ArrowLeft className="min-h-6 min-w-6" />,
          onClick: () => {
            onBack();
          },
        }
      : undefined,
    hideCloseButton: !isFirst,
  };
};
